// Shared duration/hours formatting for the Kronos Report views.

export function formatDuration(seconds: number): string {
  if (seconds <= 0) return '—';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}

export function formatHoursDecimal(seconds: number): string {
  const h = seconds / 3600;
  return `${h.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}h`;
}
